// Full-page i18n dictionary for Ino Elites (English / Japanese / Chinese).
export const LANG_ORDER = ["en", "ja", "zh"];

export const translations = {
  en: {
    langNames: { en: "English", ja: "Japanese", zh: "Chinese" },
    nav: { systems: "SYSTEMS", genres: "GENRES", world: "WORLD", arenas: "ARENAS", wishlist: "Wishlist" },
    hero: {
      eyebrow: "AKAYORI INTERACTIVE — SURVIVAL ACTION",
      subtitle:
        "An anime-inspired survival action game set on a hidden futuristic island near Japan. Battle with an ever-growing arsenal, uncover the mysteries of the island, and rise among the Elites. Every fight is a step closer to glory — or defeat.",
      wishlist: "Wishlist Now",
      explore: "Explore the Island",
      statusLabel: "STATUS",
      statusValue: "IN DEVELOPMENT // COMING SOON",
    },
    features: {
      overline: "// SYSTEMS",
      headingPre: "Survive. Evolve.",
      headingGlitch: "Dominate.",
      cards: [
        { title: "Ever-Growing Arsenal", desc: "Scavenge, craft and master an armory that never stops expanding. The longer you survive, the deadlier you become." },
        { title: "Reincarnation", desc: "Death is not the end. Fall, and return in an evolved form — remembering every defeat. Hunt the living to grow stronger." },
        { title: "Shifting Arenas", desc: "Underground tunnels, neon carnivals, holographic meltdowns. The island reshapes the battlefield every single match." },
        { title: "Become an Elite", desc: "Choose your Elite and climb a televised spectacle watched across the world. Glory, sponsorships and legend await." },
      ],
    },
    genres: {
      overline: "// GENRES",
      headingPre: "Choose your",
      headingGlitch: "path",
      subtitle: "Every playable Elite masters one of three core genres. Find the style that fits your fight.",
      roles: { health: "Health Genre", offense: "Offense Genre", defense: "Defense Genre" },
      desc: {
        astryx: "The vanguard of vitality. Astryx Elites sustain, mend and outlast — turning pure survival into a weapon that wears the enemy down.",
        zenith: "Relentless aggression. Zenith Elites strike first, strike hardest, and never let the pressure drop until the arena falls silent.",
        vanta: "The immovable wall. Vanta Elites absorb everything the island throws at them and turn unbreakable defense into total dominance.",
      },
    },
    world: {
      overline: "// THE WORLD",
      headingLine1: "Year 2060.",
      headingPre: "A",
      headingGlitch: "hidden island.",
      paragraphs: [
        "Off the coast of Japan rises a city of glass and light — towering skyscrapers crowned by a single central spire, undiscoverable to the outside world.",
        "Behind its walls, the island stages a televised survival spectacle broadcast across Asia, where VIPs in the tower wager fortunes on the fighters below.",
        "Its Elites cannot truly die. Struck down, they return — evolved, and haunted by the memory of every fall.",
        "And watching over it all, the masked HeadMaster smiles.",
      ],
      caption: "THE CENTRAL SPIRE",
    },
    arenas: {
      overline: "// ARENAS",
      headingPre: "Battlegrounds of",
      headingGlitch: "the island",
      note: "REFERENCE IMAGERY. ENVIRONMENTS IN DEVELOPMENT.",
      labels: ["UNDERGROUND TUNNELS", "NEON CARNIVAL", "HOLOGRAPHIC MELTDOWN"],
    },
    release: {
      overline: "// RELEASE",
      heading: "Coming Soon",
      body: "No release date yet — Ino Elites is in active development. Wishlist now to be first through the gates when the island finally opens.",
      wishlist: "Wishlist Now",
      platforms: "PLATFORMS TO BE ANNOUNCED",
    },
    newsletter: {
      overline: "// JOIN THE ELITE",
      headingPre: "Be first into",
      headingGlitch: "the arena",
      body: "Wishlist alerts, character reveals, beta access and dev updates — straight to your inbox. No spam. Just the island.",
      notify: "Notify Me",
      toastSuccess: "YOU'RE ON THE LIST // welcome to the island",
      toastError: "HOLD ON // enter a valid email address",
      toastExists: "ALREADY ENLISTED // you're already on the list",
      toastFail: "SYSTEM ERROR // please try again in a moment",
      sending: "Sending...",
    },
    footer: {
      tagline: "An anime-inspired survival action game by Akayori Interactive. Built for the players who refuse to settle for second place.",
      contactLabel: "CONTACT",
      colGame: "GAME",
      colStudio: "STUDIO",
      colSupport: "SUPPORT",
      links: {
        systems: "Systems", genres: "Genres", world: "World", arenas: "Arenas",
        about: "About", careers: "Careers", presskit: "Press Kit", news: "News",
        faq: "FAQ", contact: "Contact", privacy: "Privacy", terms: "Terms",
      },
      copyright: "© 2026 AKAYORI INTERACTIVE. ALL RIGHTS RESERVED.",
      slogan: "EVERY FIGHT. EVERY GLORY.",
    },
    legal: {
      back: "Back to Home",
      lastUpdated: "Last updated: June 2026",
      privacy: {
        title: "Privacy Policy",
        intro: "Akayori Interactive (\"we\", \"us\", \"our\") respects your privacy. This Privacy Policy explains how we collect, use and protect your information when you visit the Ino Elites website and join our wishlist.",
        sections: [
          { h: "Information We Collect", p: ["When you join our wishlist, we collect the email address you provide and your selected language preference. We may also collect basic, non-identifying technical data such as browser type and general usage statistics."] },
          { h: "How We Use Your Information", p: ["We use your email address solely to send you Ino Elites updates — including wishlist confirmations, character reveals, beta access invitations and development news. We do not sell, rent or trade your personal information."] },
          { h: "Email Communications", p: ["Welcome and update emails are delivered through Resend, our trusted email provider. Every email includes the ability to unsubscribe at any time. Once you unsubscribe, we stop sending you marketing emails."] },
          { h: "Data Storage & Security", p: ["Your information is stored securely in our database. We apply reasonable technical and organisational measures to protect it against unauthorised access, loss or misuse."] },
          { h: "Cookies & Local Storage", p: ["We use your browser's local storage to remember your language preference. We do not use tracking cookies for advertising purposes."] },
          { h: "Your Rights", p: ["You may request access to, correction of, or deletion of your personal data at any time by contacting us. We will respond to all reasonable requests promptly."] },
          { h: "Children's Privacy", p: ["The Ino Elites website is not directed at children under 13, and we do not knowingly collect personal information from them."] },
          { h: "Changes to This Policy", p: ["We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date."] },
          { h: "Contact Us", p: ["If you have any questions about this Privacy Policy, please contact us at inoelitesofficial@gmail.com."] },
        ],
      },
      terms: {
        title: "Terms of Service",
        intro: "These Terms of Service (\"Terms\") govern your access to and use of the Ino Elites website operated by Akayori Interactive. By using this site, you agree to these Terms.",
        sections: [
          { h: "Acceptance of Terms", p: ["By accessing or using the Ino Elites website, you confirm that you accept these Terms and agree to comply with them. If you do not agree, please do not use the site."] },
          { h: "Use of the Site", p: ["This website is provided for informational and promotional purposes related to the upcoming game Ino Elites. You agree to use the site only for lawful purposes and in a way that does not infringe the rights of others."] },
          { h: "Intellectual Property", p: ["All content on this site — including the Ino Elites name, logos, artwork, characters, text and design — is the property of Akayori Interactive and is protected by intellectual property laws. You may not reproduce or distribute it without our written permission."] },
          { h: "Wishlist & Newsletter", p: ["By joining the wishlist, you consent to receiving email communications about Ino Elites. You can withdraw your consent at any time using the unsubscribe link in any email."] },
          { h: "User Conduct", p: ["You agree not to misuse the site, attempt to gain unauthorised access, interfere with its operation, or use it to transmit harmful or unlawful content."] },
          { h: "Disclaimers", p: ["Ino Elites is in active development. All content, features, artwork and release information are subject to change and are provided \"as is\" without warranties of any kind."] },
          { h: "Limitation of Liability", p: ["To the fullest extent permitted by law, Akayori Interactive shall not be liable for any indirect, incidental or consequential damages arising from your use of the site."] },
          { h: "Changes to These Terms", p: ["We may revise these Terms at any time. Continued use of the site after changes are posted constitutes acceptance of the updated Terms."] },
          { h: "Governing Law", p: ["These Terms are governed by applicable law. Any disputes will be resolved in accordance with the jurisdiction in which Akayori Interactive operates."] },
          { h: "Contact Us", p: ["For any questions about these Terms, please contact us at inoelitesofficial@gmail.com."] },
        ],
      },
    },
  },

  ja: {
    langNames: { en: "英語", ja: "日本語", zh: "中国語" },
    nav: { systems: "システム", genres: "流派", world: "世界", arenas: "闘技場", wishlist: "ウィッシュリスト" },
    hero: {
      eyebrow: "アカヨリ・インタラクティブ — サバイバルアクション",
      subtitle:
        "日本近海の隠された未来の島を舞台にした、アニメ風サバイバルアクション。増え続ける武器で戦い、島の謎を解き明かし、エリートへと駆け上がれ。すべての戦いが、栄光か敗北への一歩となる。",
      wishlist: "ウィッシュリストに追加",
      explore: "島を探索する",
      statusLabel: "ステータス",
      statusValue: "開発中 // 近日公開",
    },
    features: {
      overline: "// システム",
      headingPre: "生き残れ。進化せよ。",
      headingGlitch: "支配せよ。",
      cards: [
        { title: "増え続ける武器庫", desc: "拾い、作り、極めろ。決して止まらず増え続ける武器庫。長く生き残るほど、その手はより致命的になる。" },
        { title: "輪廻転生", desc: "死は終わりではない。倒れても進化した姿で蘇り、すべての敗北を記憶する。生者を狩り、さらに強くなれ。" },
        { title: "変化する闘技場", desc: "地下トンネル、ネオンのカーニバル、ホログラムの崩壊。島は戦いのたびに戦場を作り替える。" },
        { title: "エリートになれ", desc: "エリートを選び、世界中が見守る放送スペクタクルを駆け上がれ。栄光、スポンサー、そして伝説が待つ。" },
      ],
    },
    genres: {
      overline: "// 流派",
      headingPre: "選べ、あなたの",
      headingGlitch: "道を",
      subtitle: "プレイ可能なエリートは、3つの基本流派のいずれかを極める。あなたの戦いに合うスタイルを見つけよう。",
      roles: { health: "回復タイプ", offense: "攻撃タイプ", defense: "防御タイプ" },
      desc: {
        astryx: "生命力の先駆者。アストリクスのエリートは、支え、癒し、耐え抜く——生存そのものを、敵を削る武器に変える。",
        zenith: "容赦なき攻撃。ゼニスのエリートは先手で最も激しく打ち、闘技場が静まるまで圧力を緩めない。",
        vanta: "不動の壁。ヴァンタのエリートは島の猛攻をすべて受け止め、鉄壁の防御を完全な支配へと変える。",
      },
    },
    world: {
      overline: "// 世界 ・ 二〇六〇",
      headingLine1: "二〇六〇年。",
      headingPre: "ある",
      headingGlitch: "隠された島。",
      paragraphs: [
        "日本の沖に、ガラスと光の都市がそびえる——中央にそびえる一本の尖塔を頂く摩天楼群は、外の世界からは決して見つけられない。",
        "その壁の内側で、島はアジア全土に放送される生存スペクタクルを繰り広げ、塔のVIPたちは下界の戦士たちに莫大な賭けを投じる。",
        "そのエリートたちは真には死ねない。倒されても蘇り——進化し、すべての敗北の記憶に苛まれる。",
        "そしてそのすべてを見下ろし、仮面のヘッドマスターは微笑む。",
      ],
      caption: "中央尖塔",
    },
    arenas: {
      overline: "// 闘技場",
      headingPre: "",
      headingGlitch: "島の戦場",
      note: "参考イメージ。環境は開発中。",
      labels: ["地下トンネル", "ネオンカーニバル", "ホログラム崩壊"],
    },
    release: {
      overline: "// 配信",
      heading: "近日公開",
      body: "発売日は未定——『イノエリート』は鋭意開発中。島が開かれるその時、誰よりも早く飛び込めるよう、今すぐウィッシュリストへ。",
      wishlist: "ウィッシュリストに追加",
      platforms: "対応プラットフォームは後日発表",
    },
    newsletter: {
      overline: "// 参戦せよ",
      headingPre: "誰よりも早く",
      headingGlitch: "闘技場へ",
      body: "ウィッシュリスト通知、キャラクター公開、ベータアクセス、開発情報——あなたの受信箱へ直接。スパムなし。あるのは島だけ。",
      notify: "通知を受け取る",
      toastSuccess: "登録完了 // 島へようこそ",
      toastError: "お待ちを // 有効なメールアドレスを入力してください",
      toastExists: "登録済み // すでにリストに登録されています",
      toastFail: "システムエラー // 少し後にもう一度お試しください",
      sending: "送信中...",
    },
    footer: {
      tagline: "アカヨリ・インタラクティブによるアニメ風サバイバルアクション。二番手で満足しないプレイヤーのために。",
      contactLabel: "お問い合わせ",
      colGame: "ゲーム",
      colStudio: "スタジオ",
      colSupport: "サポート",
      links: {
        systems: "システム", genres: "流派", world: "世界", arenas: "闘技場",
        about: "概要", careers: "採用情報", presskit: "プレスキット", news: "ニュース",
        faq: "よくある質問", contact: "お問い合わせ", privacy: "プライバシー", terms: "利用規約",
      },
      copyright: "© 2026 AKAYORI INTERACTIVE. 無断転載を禁じます。",
      slogan: "すべての戦い。すべての栄光。",
    },
    legal: {
      back: "ホームに戻る",
      lastUpdated: "最終更新：2026年6月",
      privacy: {
        title: "プライバシーポリシー",
        intro: "アカヨリ・インタラクティブ（以下「当社」）はお客様のプライバシーを尊重します。本プライバシーポリシーは、Ino Elites のウェブサイトをご利用いただき、ウィッシュリストにご登録いただく際に、当社がどのように情報を収集・利用・保護するかを説明するものです。",
        sections: [
          { h: "収集する情報", p: ["ウィッシュリストにご登録いただく際、ご提供いただくメールアドレスおよび選択された言語設定を収集します。また、ブラウザの種類や一般的な利用統計など、個人を特定しない基本的な技術データを収集する場合があります。"] },
          { h: "情報の利用方法", p: ["お客様のメールアドレスは、ウィッシュリストの確認、キャラクター公開、ベータアクセスの招待、開発情報など、Ino Elites に関する最新情報をお送りするためにのみ使用します。当社がお客様の個人情報を販売・貸与・取引することはありません。"] },
          { h: "メールでの連絡", p: ["ウェルカムメールおよび更新メールは、信頼できるメール配信事業者である Resend を通じて配信されます。すべてのメールにはいつでも配信停止できる機能が含まれています。配信停止後は、マーケティングメールの送信を停止します。"] },
          { h: "データの保管とセキュリティ", p: ["お客様の情報は当社のデータベースに安全に保管されます。不正アクセス、紛失、悪用から保護するため、合理的な技術的・組織的措置を講じています。"] },
          { h: "クッキーとローカルストレージ", p: ["お客様の言語設定を記憶するために、ブラウザのローカルストレージを使用します。広告目的のトラッキングクッキーは使用していません。"] },
          { h: "お客様の権利", p: ["お客様はいつでも当社にご連絡いただくことで、個人データへのアクセス、訂正、削除を請求できます。すべての合理的なご請求には速やかに対応いたします。"] },
          { h: "子どものプライバシー", p: ["Ino Elites のウェブサイトは13歳未満の子どもを対象としておらず、当社が故意に子どもの個人情報を収集することはありません。"] },
          { h: "本ポリシーの変更", p: ["当社は本プライバシーポリシーを随時更新することがあります。変更があった場合は、改訂日とともに本ページに掲載します。"] },
          { h: "お問い合わせ", p: ["本プライバシーポリシーに関するご質問は、inoelitesofficial@gmail.com までお問い合わせください。"] },
        ],
      },
      terms: {
        title: "利用規約",
        intro: "本利用規約（以下「本規約」）は、アカヨリ・インタラクティブが運営する Ino Elites ウェブサイトへのアクセスおよび利用に適用されます。本サイトを利用することで、本規約に同意したものとみなされます。",
        sections: [
          { h: "規約への同意", p: ["Ino Elites のウェブサイトにアクセスまたは利用することで、本規約に同意し、これを遵守することに同意したものとします。同意いただけない場合は、本サイトをご利用にならないでください。"] },
          { h: "サイトの利用", p: ["本ウェブサイトは、近日公開予定のゲーム Ino Elites に関する情報提供および宣伝を目的として提供されています。お客様は本サイトを合法的な目的でのみ、かつ他者の権利を侵害しない方法で利用することに同意するものとします。"] },
          { h: "知的財産", p: ["Ino Elites の名称、ロゴ、アートワーク、キャラクター、テキスト、デザインを含む本サイトのすべてのコンテンツは、アカヨリ・インタラクティブに帰属し、知的財産法によって保護されています。当社の書面による許可なく複製または配布することはできません。"] },
          { h: "ウィッシュリストとニュースレター", p: ["ウィッシュリストに登録することで、Ino Elites に関するメール連絡を受け取ることに同意したものとします。いずれのメールに記載された配信停止リンクからも、いつでも同意を撤回できます。"] },
          { h: "ユーザーの行為", p: ["お客様は、本サイトを悪用したり、不正アクセスを試みたり、その運営を妨害したり、有害または違法なコンテンツの送信に利用しないことに同意するものとします。"] },
          { h: "免責事項", p: ["Ino Elites は鋭意開発中です。すべてのコンテンツ、機能、アートワーク、配信情報は変更される可能性があり、いかなる保証もなく「現状のまま」提供されます。"] },
          { h: "責任の制限", p: ["法律で認められる最大限の範囲において、アカヨリ・インタラクティブは、本サイトの利用に起因する間接的、付随的、または結果的損害について一切責任を負いません。"] },
          { h: "本規約の変更", p: ["当社はいつでも本規約を改訂することがあります。変更の掲載後も本サイトを継続して利用することは、改訂された規約への同意を構成します。"] },
          { h: "準拠法", p: ["本規約は適用される法律に準拠します。紛争は、アカヨリ・インタラクティブが事業を行う管轄区域に従って解決されます。"] },
          { h: "お問い合わせ", p: ["本規約に関するご質問は、inoelitesofficial@gmail.com までお問い合わせください。"] },
        ],
      },
    },
  },

  zh: {
    langNames: { en: "英语", ja: "日语", zh: "中文" },
    nav: { systems: "系统", genres: "流派", world: "世界", arenas: "竞技场", wishlist: "心愿单" },
    hero: {
      eyebrow: "AKAYORI INTERACTIVE — 生存动作游戏",
      subtitle:
        "一款以日本近海隐秘未来岛屿为舞台的动漫风生存动作游戏。使用不断扩充的武器库战斗，揭开岛屿的谜团，跻身精英之列。每一场战斗，都是迈向荣耀或败北的一步。",
      wishlist: "加入心愿单",
      explore: "探索岛屿",
      statusLabel: "状态",
      statusValue: "开发中 // 即将推出",
    },
    features: {
      overline: "// 系统",
      headingPre: "生存。进化。",
      headingGlitch: "主宰。",
      cards: [
        { title: "不断成长的武器库", desc: "搜集、打造并精通永不停止扩张的武器库。生存得越久，你就越致命。" },
        { title: "轮回转生", desc: "死亡并非终点。倒下后将以进化之姿归来——铭记每一次失败。猎杀生者，变得更强。" },
        { title: "变幻的竞技场", desc: "地下隧道、霓虹嘉年华、全息崩塌。岛屿在每一场对战中重塑战场。" },
        { title: "成为精英", desc: "选择你的精英，攀上举世瞩目的直播盛典。荣耀、赞助与传奇正等待着你。" },
      ],
    },
    genres: {
      overline: "// 流派",
      headingPre: "选择你的",
      headingGlitch: "道路",
      subtitle: "每位可操作的精英都精通三大核心流派之一。找到适合你的战斗风格。",
      roles: { health: "治疗系", offense: "进攻系", defense: "防御系" },
      desc: {
        astryx: "生命力的先锋。Astryx 精英持续支援、治疗并坚持到底——将纯粹的生存化为消耗敌人的武器。",
        zenith: "无情的攻势。Zenith 精英率先出击、火力最猛，直到竞技场归于寂静都不松懈压制。",
        vanta: "不动之墙。Vanta 精英承受岛屿的一切攻击，将坚不可摧的防御化为彻底的统治。",
      },
    },
    world: {
      overline: "// 世界 ・ 二〇六〇",
      headingLine1: "公元2060年。",
      headingPre: "一座",
      headingGlitch: "隐秘之岛。",
      paragraphs: [
        "在日本近海，矗立着一座玻璃与光芒之城——高耸的摩天楼群以一座中央尖塔为冠，外界永远无法发现。",
        "在高墙之内，岛屿上演着向全亚洲直播的生存盛典，塔中的贵宾们为下方的战士押下巨额赌注。",
        "岛上的精英无法真正死去。被击倒后他们会归来——不断进化，却被每一次倒下的记忆所纠缠。",
        "而俯瞰这一切的，是戴着面具的主宰者，正面带微笑。",
      ],
      caption: "中央尖塔",
    },
    arenas: {
      overline: "// 竞技场",
      headingPre: "",
      headingGlitch: "岛屿的战场",
      note: "参考图像。场景仍在开发中。",
      labels: ["地下隧道", "霓虹嘉年华", "全息崩塌"],
    },
    release: {
      overline: "// 发行",
      heading: "即将推出",
      body: "发售日期尚未公布——《Ino Elites》正在火热开发中。立即加入心愿单，在岛屿开启之时抢先入场。",
      wishlist: "加入心愿单",
      platforms: "支持平台稍后公布",
    },
    newsletter: {
      overline: "// 加入精英",
      headingPre: "抢先进入",
      headingGlitch: "竞技场",
      body: "心愿单提醒、角色公开、Beta 测试资格与开发动态——直达你的收件箱。绝无垃圾邮件，只有岛屿。",
      notify: "通知我",
      toastSuccess: "已加入名单 // 欢迎来到岛屿",
      toastError: "请稍候 // 请输入有效的电子邮箱",
      toastExists: "已在名单中 // 你已加入心愿单",
      toastFail: "系统错误 // 请稍后再试",
      sending: "发送中...",
    },
    footer: {
      tagline: "由 Akayori Interactive 打造的动漫风生存动作游戏。为绝不甘居第二的玩家而生。",
      contactLabel: "联系我们",
      colGame: "游戏",
      colStudio: "工作室",
      colSupport: "支持",
      links: {
        systems: "系统", genres: "流派", world: "世界", arenas: "竞技场",
        about: "关于", careers: "招聘", presskit: "媒体资料", news: "新闻",
        faq: "常见问题", contact: "联系我们", privacy: "隐私", terms: "条款",
      },
      copyright: "© 2026 AKAYORI INTERACTIVE. 版权所有。",
      slogan: "每一场战斗。每一份荣耀。",
    },
    legal: {
      back: "返回首页",
      lastUpdated: "最后更新：2026年6月",
      privacy: {
        title: "隐私政策",
        intro: "Akayori Interactive（以下简称“我们”）尊重您的隐私。本隐私政策说明当您访问 Ino Elites 网站并加入心愿单时，我们如何收集、使用和保护您的信息。",
        sections: [
          { h: "我们收集的信息", p: ["当您加入心愿单时，我们会收集您提供的电子邮箱地址以及您所选择的语言偏好。我们还可能收集浏览器类型和一般使用统计等不识别个人身份的基本技术数据。"] },
          { h: "我们如何使用您的信息", p: ["我们仅使用您的电子邮箱地址向您发送 Ino Elites 的最新动态——包括心愿单确认、角色公开、Beta 测试邀请和开发新闻。我们绝不会出售、出租或交易您的个人信息。"] },
          { h: "电子邮件通讯", p: ["欢迎邮件和更新邮件通过我们信赖的邮件服务商 Resend 发送。每封邮件都包含随时退订的功能。一旦您退订，我们将停止向您发送营销邮件。"] },
          { h: "数据存储与安全", p: ["您的信息安全地存储在我们的数据库中。我们采取合理的技术和组织措施，防止其遭到未经授权的访问、丢失或滥用。"] },
          { h: "Cookie 与本地存储", p: ["我们使用浏览器的本地存储来记住您的语言偏好。我们不会出于广告目的使用跟踪 Cookie。"] },
          { h: "您的权利", p: ["您可以随时联系我们，请求访问、更正或删除您的个人数据。我们将及时回应所有合理的请求。"] },
          { h: "儿童隐私", p: ["Ino Elites 网站并非面向13岁以下的儿童，我们不会在知情的情况下收集他们的个人信息。"] },
          { h: "本政策的变更", p: ["我们可能会不时更新本隐私政策。任何变更都将连同更新的修订日期一起发布在本页面上。"] },
          { h: "联系我们", p: ["如果您对本隐私政策有任何疑问，请通过 inoelitesofficial@gmail.com 与我们联系。"] },
        ],
      },
      terms: {
        title: "服务条款",
        intro: "本服务条款（以下简称“条款”）适用于您对 Akayori Interactive 运营的 Ino Elites 网站的访问和使用。使用本网站即表示您同意这些条款。",
        sections: [
          { h: "条款的接受", p: ["访问或使用 Ino Elites 网站即表示您确认接受这些条款并同意遵守。如果您不同意，请勿使用本网站。"] },
          { h: "网站的使用", p: ["本网站旨在提供与即将推出的游戏 Ino Elites 相关的信息和宣传。您同意仅将本网站用于合法目的，且不侵犯他人的权利。"] },
          { h: "知识产权", p: ["本网站上的所有内容——包括 Ino Elites 名称、徽标、美术作品、角色、文字和设计——均为 Akayori Interactive 的财产，并受知识产权法保护。未经我们书面许可，您不得复制或分发。"] },
          { h: "心愿单与新闻通讯", p: ["加入心愿单即表示您同意接收有关 Ino Elites 的电子邮件通讯。您可以随时使用任何邮件中的退订链接撤回您的同意。"] },
          { h: "用户行为", p: ["您同意不会滥用本网站、试图未经授权访问、干扰其运行，或利用其传输有害或非法内容。"] },
          { h: "免责声明", p: ["Ino Elites 正在积极开发中。所有内容、功能、美术作品和发行信息均可能发生变化，并按“现状”提供，不附带任何形式的保证。"] },
          { h: "责任限制", p: ["在法律允许的最大范围内，Akayori Interactive 对因您使用本网站而产生的任何间接、附带或后果性损害概不负责。"] },
          { h: "条款的变更", p: ["我们可能随时修订这些条款。在变更发布后继续使用本网站即构成对更新条款的接受。"] },
          { h: "适用法律", p: ["本条款受适用法律管辖。任何争议将根据 Akayori Interactive 经营所在的司法管辖区予以解决。"] },
          { h: "联系我们", p: ["如对本条款有任何疑问，请通过 inoelitesofficial@gmail.com 与我们联系。"] },
        ],
      },
    },
  },
};
